<div class="inner-addon right-addon">
    <i class="oi oi-minus" *ngIf="capOn" style="margin-top: 0.9em; font-size: .8em; margin-right: 1.2px "></i>
    <i *ngIf="capOn" class="oi oi-chevron-top"></i>
    <input type="password"
           class="form-control"
           [(ngModel)]="inputValue"
           [required]="required"
           [disabled]="disabled"
           [placeholder]="placeholder"
           (ngModelChange)="onValueChange($event)"
           (blur)="blurIN()"
           (input)="changeIN()"          
           autocomplete="new-password" />
    <i *ngIf="capOn">Warning: CAPS Lock is on!</i>
</div>